import { render, staticRenderFns } from "./Mailrecord.vue?vue&type=template&id=3f133cd1&scoped=true&"
import script from "./Mailrecord.vue?vue&type=script&lang=js&"
export * from "./Mailrecord.vue?vue&type=script&lang=js&"
import style0 from "./Mailrecord.vue?vue&type=style&index=0&id=3f133cd1&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f133cd1",
  null
  
)

export default component.exports